import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ParadigmaModal from "../../../components/ParadigmaModal/ParadigmaModal.js"
import api from "../../../api";


import { Row, Col, Label, Input, InputGroup, FormFeedback } from 'reactstrap';

import CamposSelect from "../../ProyectosConfig/Plan_Campos/CamposSelect.js"

class AgregarCampo extends Component {
    constructor(props) {
        super(props);
        this.state = {
        };
    }

    static propTypes = {
        onSubmit: PropTypes.func.isRequired,
        label: PropTypes.string,
        tabs: PropTypes.any,
    }

    render() {
        return (
            <ParadigmaModal
                onSubmit={(callback) => this.props.onSubmit(callback)}
                id={this.props.id}
                title={"Seleccione un Campo"}
                buttonIcon={"fa fa-plus fa-lg"}
                
                saveButton={true}
                closeButton={true}
            >
                <Row>
                    <Col className="col-12">
                        <CamposSelect excluded={this.props.tabs.map(a => a.campo_id)} />
                    </Col>
                </Row>
            </ParadigmaModal>
        );
    }
}

export default AgregarCampo;



// WEBPACK FOOTER //
// ./src/views/Proyectos/Procedimiento2/AgregarCampo.js